import {Button} from "antd";
import {StyledNoUpcomingCallBox} from "../../calls/upcoming-calls/upcoming-calls.style";
import {Link} from "react-router-dom";

export function NoProducts() {
  return (
    <StyledNoUpcomingCallBox>
      <p className="info-text">
        You do not have any product at the moment. Create a new product to get started.
      </p>
      <div>
        <Link to="/products/new">
          <Button size="small" block type="primary" htmlType="button">
            Create a new product
          </Button>
        </Link>
      </div>
    </StyledNoUpcomingCallBox>
  );
}
